import {GroupData} from '@/types/group';
import {Autocomplete, FormControl, TextField} from '@mui/material';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

interface GroupFilterProps {
  selectedGroup: string | null;
  onGroupChange: (selectedGroup: string) => void;
  myGroups: GroupData[];
}

const GroupFilter: React.FC<GroupFilterProps> = ({
  selectedGroup,
  onGroupChange,
  myGroups
}) => {
  const {t} = useTranslation();

  const handleGroupChange = useCallback(
    (
      event: React.SyntheticEvent,
      newValue: {title: string; _id: string} | null
    ) => {
      if (newValue) {
        onGroupChange(newValue._id);
      }
    },
    [onGroupChange]
  );
  return (
    <FormControl fullWidth>
      <Autocomplete
        options={myGroups}
        getOptionLabel={(option) => option.title}
        value={myGroups.find((group) => group._id === selectedGroup) || null}
        onChange={handleGroupChange}
        renderInput={(params) => (
          <TextField {...params} label={t('group')} placeholder={t('search')} />
        )}
      />
    </FormControl>
  );
};
export default GroupFilter;
